import { addForm, technoLogies, viewColomn } from '../common';

function getPastDates(years) {
  const currentDate = new Date();
  const pastDates = [];
  for (let i = 0; i < years; i++) {
    const pastDate = new Date(currentDate.getFullYear() - i, currentDate.getMonth(), currentDate.getDate());
    pastDates.push(pastDate.getFullYear());
  }
  return pastDates;
}

function getCourse() {
  return ['SSC', 'HSC', 'BTech', 'MTech', 'PHD', 'BSC', 'BCA', 'MCA', 'MSBTE', 'BA', 'BCOM'];
}



export const resumesConfig = {
  api: () => '/resumes',
  title: 'Resumes',
  isActionTab: true,
  modalTitle: (action) => `${action} Resume`,
  moreActions: [
    {
      noActionRequired: true,
      name: 'View PDF',
      action: 'pdf',
      getKey: (value) => value.pdfFile
    },
  ],
  getColumns: () => {
    return [
      {
        title: 'Developer Name',
        dataIndex: 'developerName',
        key: 'developerName',
        render: (name) => {
          return (name && name.firstName) ? [name.firstName, name.lastName].join(' ') : '';
        }
      },
      {
        title: 'Experience',
        dataIndex: 'experience',
        key: 'experience',
        render: (name) => {
          return name + '+';
        }
      },
      ...viewColomn(true)
    ];
  },
  getFormColumns: () => {
    return [
      {
        title: 'Developer Name',
        dataIndex: 'developerName',
        key: 'developerName',
        isRequired: true,
        type: 'select',
        isCombo: true,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Experience',
        dataIndex: 'experience',
        key: 'experience',
        isRequired: true,
        type: 'number',
        formClassName: 'col-2 pb-2',
      },
      {
        title: 'Technologies',
        dataIndex: 'technology',
        key: 'technology',
        isRequired: true,
        multiple: true,
        type: 'select',
        children: technoLogies(),
        formClassName: 'col-6 pb-2',
      },
      {
        title: 'Other Technologies',
        dataIndex: 'otherTechnology',
        key: 'otherTechnology',
        placeholder: 'add comma seprated',
        type: 'textarea',
        rows: 1,
        formClassName: 'col-4 pb-2',
      },
      {
        heading: 'Projects',
        title: 'Projects',
        dataIndex: 'projects',
        key: 'projects',
        type: 'form',
        form: [
          [
            {
              title: 'Project Name',
              dataIndex: 'project',
              key: 'project',
              isRequired: true,
              type: 'select',
              isCombo: true,
              formClassName: 'col-4 pb-2',
            },
            {
              title: 'Start Date',
              dataIndex: 'startDate',
              key: 'startDate',
              type: 'date',
              formClassName: 'col-4 pb-2',
            },
            {
              title: 'End Date',
              dataIndex: 'endDate',
              key: 'endDate',
              type: 'date',
              formClassName: 'col-4 pb-2',
            },
          ],
        ],
      },
      {
        heading: 'Skills',
        title: 'Skills',
        dataIndex: 'skills',
        key: 'skills',
        type: 'form',
        form: [
          [
            {
              title: 'Select',
              dataIndex: 'skillsPlatform',
              key: 'skillsPlatform',
              isRequired: true,
              type: 'select',
              children: ['Tools and Technologies', 'Operating System', 'Database',
                'Scripting Languages', 'Programming Languages', 'Languages', 'Cloud Platforms'].map(ele => ({ name: ele, value: ele })),
              formClassName: 'col-4 pb-2',
            },
            {
              title: 'Skils',
              dataIndex: 'skils',
              key: 'skils',
              multiple: true,
              type: 'select',
              children: [
                'VS Code', 'MS Office', 'Subline', 'bit-bucket', 'GitHub', 'GitLab',
                'Windows', 'Ubuntu', 'MySQL', 'MongoDB', 'postgresql',
                'JS', 'TS', 'JQuery', 'CSS', 'SASS',
                'C', 'Java', 'SpringBoot', 'Microservices', 'Nodejs', 'ReactJS', 'Angular2+', 'AngularJS', 'NextJS', 'NestJS',
                '.Net', 'AWS', 'GoogleCloud', 'Azure', 'Jira', 'Devops'
              ].map(ele => ({ name: ele, value: ele })),
              formClassName: 'col-4 pb-2',
            },
            {
              title: 'Other Skils',
              dataIndex: 'otherskils',
              key: 'otherskils',
              type: 'textarea',
              placeholder: 'Enter comma seprated',
              rows: 1,
              formClassName: 'col-4 pb-2',
            },
          ],
        ],
      },
      {
        heading: 'Educations',
        title: 'Educations',
        dataIndex: 'educations',
        key: 'educations',
        type: 'form',
        form: [
          [
            {
              title: 'Standard',
              dataIndex: 'standard',
              key: 'standard',
              isRequired: true,
              type: 'select',
              children: ['10th', '12th', 'Diploma', 'Degree', 'PG'].map(ele => ({ name: ele, value: ele })),
              formClassName: 'col-4 pb-2',
            },
            {
              title: 'College/School',
              dataIndex: 'college',
              key: 'college',
              formClassName: 'col-4 pb-2',
            },
            {
              title: 'Course',
              dataIndex: 'course',
              key: 'course',
              isRequired: true,
              type: 'select',
              children: getCourse().map(ele => ({ name: ele, value: ele })),
              formClassName: 'col-4 pb-2',
            },
            {
              title: 'Passing Year',
              dataIndex: 'passingYear',
              key: 'passingYear',
              type: 'select',
              children: getPastDates(30).map(ele => ({ name: ele, value: ele })),
              formClassName: 'col-4 pb-2',
            },
          ],
        ],
      },
      ...addForm()
    ];
  },
  combo: [
    {
      name: 'project',
      api: '/employeeProjects',
      idKey: '_id',
      nameKey: 'projectName',
    },
    {
      name: 'approvalFrom',
      api: '/users/CEO/list',
      idKey: '_id',
      nameKey: ['firstName', 'middelName', 'lastName'],
    },
    {
      name: 'developerName',
      api: '/users',
      idKey: '_id',
      nameKey: ['firstName', 'lastName'],
    },
  ],
  getData: () => ({}),
  actions: [
    { name: 'Add Resume', isModal: true, settings: { type: 'primary' } },
    { name: 'Return', isBack: true, settings: { type: 'primary' } },
  ],
};
